import { render, staticRenderFns } from "./LogoWrapper.vue?vue&type=template&id=126e1ce0"
import script from "./LogoWrapper.vue?vue&type=script&lang=js"
export * from "./LogoWrapper.vue?vue&type=script&lang=js"
import style0 from "./LogoWrapper.vue?vue&type=style&index=0&id=126e1ce0&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/checkout-webapp-v2/checkout-webapp-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('126e1ce0')) {
      api.createRecord('126e1ce0', component.options)
    } else {
      api.reload('126e1ce0', component.options)
    }
    module.hot.accept("./LogoWrapper.vue?vue&type=template&id=126e1ce0", function () {
      api.rerender('126e1ce0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project/molecules/LogoWrapper.vue"
export default component.exports